
                import "css-modules://src_components_lead_lead"
                export default {"Main":"_96e7c7","Text":"_3b33cf","Visible":"_4218a2"}
            